import { CreateBookingPageV2WithProviders } from "./CreateBookingPageV2";
import { useGreeterGuestApi } from "@greeter/matter";

export function CreateBookingPageV2RouteHandler() {
  const { api } = useGreeterGuestApi();

  return <CreateBookingPageV2WithProviders api={api} />;
}
